import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBannerComponent } from './formly-banner.component';

@NgModule({
  imports: [
    FormlyBannerComponent,
    FormlyModule.forChild({
      types: [
        { name: 'banner', component: FormlyBannerComponent },
      ],
    }),
  ],
})
export class FormlyBannerModule {}
